import { Component, OnInit } from '@angular/core';
import { StatusService } from 'src/app/services/status/status.service';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
})
export class StatusComponent implements OnInit {
    constructor(private statusService: StatusService) {}

    statusTest: any;

    ngOnInit(): void {
        this.getStatus();
    }

    get statusData() {
        return this.statusTest;
    }

    getStatus(): void {
        this.statusService.getStatus().subscribe((status) => {
            console.log(status);
            this.statusTest = status;
        });
    }
}
